<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="col-xl-7 b-center bg-size"
        :style="{
          backgroundImage:
            'url(' + require('../../assets/images/login/2.jpg') + ')',
        }"
        style="
          background-size: cover;
          background-position: center center;
          display: block;
        "
      >
        <img
          class="bg-img-cover bg-center"
          src="../../assets/images/login/2.jpg"
          alt="looginpage"
          style="display: none"
        />
      </div>
      <div class="col-xl-5 p-0">
        <!-- <button class="btn btn-danger" @click="SignOut">SignOut</button> -->
        <!-- <div class="content-container">
          <div class="section content-title-group">
            <button class="btn btn-info" @click="SignIn">SignIn</button>
            <button class="btn btn-danger" @click="SignOut">SignOut</button>
            <h2 class="title">Welcome to the Azure AD + Storage app with Vue.js</h2>
          </div>
          <div v-if="account">
            <div class="level">
              <div class="level-item title">
                You are logged in as {{ account.name }}
              </div>
            </div>
          </div>
          <div v-else>You need to authenticate to access your Azure Storage data</div>
        </div> -->
        <div class="login-card">
          <div>
            <div>
              <a class="logo text-left">
                <img
                  class="img-fluid for-light"
                  src="../../assets/images/logo/logo.png"
                  alt="looginpage"
                />
                <img
                  class="img-fluid for-dark"
                  src="../../assets/images/logo/logo_dark.png"
                  alt="looginpage"
                />
              </a>
            </div>
            <!-- <div class="login-main login-form-card login-res">
              <b-alert variant="danger" :show="!error_message==''" class="alert alert-warning inverse alert-dismissible">
                    <i class="icon-bell"></i>
                    <p>{{error_message}}</p>
              </b-alert>
              <form class="theme-form" @submit.prevent="handleSubmit">
                <h4>Sign in to account</h4>
                <p>Enter your email & password to login</p>
                <div class="form-group">
                  <label class="col-form-label">Email Address</label>
                  <input
                    class="form-control"
                    type="email"
                    required=""
                    name="email"
                    v-model="email"
                    placeholder="user@user.com"
                  />
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <input
                    class="form-control"
                    :type=type
                    name="login[password]"
                    v-model="passwordjwt"
                    required=""
                    placeholder="*********"
                  />
                  <div class="show-hide" @click="showPassword"><span class="show"> </span></div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox" />
                    <label class="text-muted" for="checkbox1"
                      >Remember password</label
                    >
                  </div>
                  <button class="btn btn-primary btn-block" type="submit">
                    Sign in
                  </button>
                </div>
                <p class="mt-4 mb-0">
                  Don't have account?
                  <router-link class="ml-2" tag="a" to="/register">
                    Create Account
                  </router-link>
                </p>
              </form>
            </div> -->
            <div>
              <!-- <b-alert variant="danger" :show="!error_message==''" class="alert alert-warning inverse alert-dismissible">
                    <i class="icon-bell"></i>
                    <p>{{error_message}}</p>
              </b-alert> -->
              <a
                class="logo text-center mt-4"
                href="javascript:void(0);"
                @click="SignIn"
              >
                <img
                  class="img-fluid for-light"
                  src="../../assets/images/login/ms-symbollockup_signin_light.png"
                  alt="looginpage"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { PublicClientApplication } from '@azure/msal-browser';
  import { authService } from './../../_services';
  import Userauth from './js/index';
  import { msal_config } from '../../constants/service';

  export default {
    name: 'login',
    data() {
      return {
        type: 'password',
        email: '',
        passwordjwt: '',
        submitted: false,
        error_message: '',
        $msalInstance: {},
        account: [],
        username: '',
        responseLogin: null,
      };
    },
    computed: {
      // JWT authentication
      loggingIn() {
        return this.$store.state.authentication.status.loggingIn;
      },
    },
    created() {
      // reset login status for JWT
      this.$store.dispatch('authentication/logout');
      this.$msalInstance = new PublicClientApplication(msal_config);
    },
    methods: {
      async SignIn() {
        this.submitted = true;
        this.error_message = '';
        var self = this;
        const loginRequest = {
          scopes: ['User.Read'],
        };
        await this.$msalInstance
          .loginPopup(loginRequest)
          .then((response) => {
            this.responseLogin = response;
            const timestampInSeconds = Math.floor(
              this.responseLogin.expiresOn.getTime() / 1000
            );
            this.username = this.responseLogin.account.username;
            authService
              .login(
                this.responseLogin.account.username,
                this.responseLogin.accessToken
              )
              .then((response) => {
                response
                  .text()
                  .then((text) => {
                    const data = text && JSON.parse(text);
                    if (!response.ok) {
                      const error = (data && data.error) || response.statusText;
                      return Promise.reject(error);
                    } else {
                      self.successed = true;
                      const user = data.data.user;
                      var userData = {
                        exp: self.getJwtExpiration(data.data.access_token),
                        // email : this.responseLogin.account.username,
                        // firstname : this.responseLogin.account.name,
                        email: user.email,
                        user_id: user._id,
                        firstname: user.name,
                        sender: user.sender,
                        access_token: data.data.access_token,
                        refresh_token: data.data.refresh_token,
                        role_ccp: data.data.role_ccp,
                        role_beacon: data.data.role_beacon,
                        // refresh_token : user.refresh_token,
                      };
                      Userauth.localLogin(userData);
                      this.$notify({
                        text: 'login is successfully',
                        type: 'success',
                      });
                      this.$router.push('/').catch();
                    }
                  })
                  .catch((error) => {
                    self.$notify({ text: `${error}`, type: 'danger' });
                    self.error_message = error;
                    let checkCompany =
                      this.responseLogin.account.username.includes(
                        '@cloudsoft.co.th'
                      );
                    setTimeout(() => {
                      if (checkCompany) {
                        window.location.href =
                          'https://login.microsoftonline.com/cloudsoftcoth.onmicrosoft.com/oauth2/logout?post_logout_redirect_uri=' +
                          msal_config.auth.redirectUri;
                      } else {
                        window.location.href =
                          'https://login.microsoftonline.com/' +
                          this.responseLogin.tenantId +
                          '/oauth2/v2.0/logout?client_id=' +
                          msal_config.auth.clientId +
                          '&post_logout_redirect_uri=' +
                          msal_config.auth.redirectUri;
                      }
                      this.responseLogin = null;
                    }, 3000);
                  });
              });
          })
          .catch((error) => {
            //this.$notify({ text: `${error}`,type: 'warn' });
            console.error(`error during authentication: ${error}`);
            this.responseLogin = null;
          });
      },
      async SignOut() {
        const logoutRequest = {
          account: this.$msalInstance.getAccountByUsername(this.username),
          postLogoutRedirectUri: msal_config.auth.redirectUri,
          mainWindowRedirectUri: msal_config.auth.redirectUri,
        };
        await this.$msalInstance
          .logoutPopup({ logoutRequest })
          .then(() => {})
          .catch((error) => {});
      },
      getJwtExpiration(token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        //const payload = Buffer.from(base64, 'base64').toString('ascii');
        const payload = window.atob(base64);
        const parsedPayload = JSON.parse(payload);
        return parsedPayload.exp;
      },
      // JWT authentication
      handleSubmit: function () {
        this.submitted = true;
        this.error_message = '';
        var self = this;
        const { email, passwordjwt } = this;
        /*const { dispatch } = this.$store;

        if (email && passwordjwt) {
          dispatch('authentication/login', { email, passwordjwt });
        }*/
        authService.login(email, passwordjwt).then((response) => {
          response
            .text()
            .then((text) => {
              const data = text && JSON.parse(text);
              if (!response.ok) {
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
              } else {
                self.successed = true;
                const user = data.data;
                var userData = {
                  email: email,
                  sender: user.sender,
                  firstname: user.firstname,
                  lastname: user.lastname,
                  access_token: user.access_token,
                  refresh_token: user.refresh_token,
                };
                Userauth.localLogin(userData);
                this.$notify({
                  text: 'login is successfully',
                  type: 'success',
                });
                // this.$router.push('/').catch();
              }
            })
            .catch((error) => {
              self.error_message = error;
            });
        });
      },
      // show/hide password
      showPassword: function () {
        if (this.type === 'password') {
          this.type = 'text';
        } else {
          this.type = 'password';
        }
      },
    },
  };
</script>
